import React, { Component, useState } from 'react';
import Dropdown from './dropdown';

const DropDownMenu = (props) => {
  const myRef = React.createRef<HTMLDivElement>();
  const { data, handleTabChange, isScrollTo } = props;
  const [selectedItem, setSelectedItem] = useState(1);
  const handleItemSelection = (id) => {
    setSelectedItem(id);
    handleTabChange && handleTabChange(id);

    if (isScrollTo != undefined && isScrollTo) scrollToTop();
  };

  // General scroll to element function
  const scrollToTop = () => {
    window.scroll({
      top: myRef.current.getBoundingClientRect().top + window.pageYOffset - 90,
      behavior: 'smooth',
    });
  };

  return (
    <div className="dd-wrapper">
      <Dropdown data={data} handleItemSelection={handleItemSelection} />
      {/* <div className="tab-content">{data.find((item) => item.id === selectedItem).source()}</div> */}
      <div className="tab-content">
        <div ref={myRef}>{data.find((tab) => tab.id === selectedItem).source()}</div>
        {/* {data.map((tab, index) => (
          <div key={index} className={`show-content ${selectedItem == tab.id ? 'active' : ''}`}>
            {selectedItem == tab.id ? tab.source() : null}
          </div>
        ))} */}
      </div>
    </div>
  );
};

export default DropDownMenu;
